export default __webpack_public_path__ + "static/media/acm_modal_banner_img.0b436228.png";